import { render, staticRenderFns } from "./JGDetail.vue?vue&type=template&id=214617a0&"
import script from "./JGDetail.vue?vue&type=script&lang=ts&"
export * from "./JGDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports